module.exports = __webpack_public_path__ + "static/media/2.5bbbe03f.svg";